import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Modal from "react-modal";
import Layouts from "../../layouts/layouts";
import Select from "react-select";

Modal.setAppElement("#root");

export default function Create_insurance() {
  const title = "Add Documents";
  const navigate = useNavigate();
  const [vehicles, setVehicles] = useState([]);
  const [leases, setLeases] = useState([]);
  const [clients, setClients] = useState([]);
  const [documents, setDocuments] = useState([]);
  const vehicleRequiredDocs =
    process.env.REACT_APP_VEHICLE_REQUIRED_DOCS?.split(",").map((v) =>
      v.trim()
    ) || [];
  const [formData, setFormData] = useState({
    vehicleId: "",
    leaseId: "",
    clientId: "",
    documenttypeId: "",
    Date: "",
    state: "",
    comments: "",
    // documentCopy: null,
    documentCopy: [],

    pocName: "",
    pocContact: "",
  });

  const [errors, setErrors] = useState({});

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vehicles`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setVehicles(response.data.vehicles);
      } catch (error) {
        console.error("Error fetching vehicles:", error);
        setVehicles([]);
      }
    };
    fetchVehicles();
  }, []);
  const handleVehicleChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      vehicleId: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchLeases = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v3/leases`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setLeases(response.data.leases);
      } catch (error) {
        console.error("Error fetching leases:", error);
        setLeases([]);
      }
    };
    fetchLeases();
  }, []);
  const handleLeaseChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      leaseId: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/clients`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClients(response.data.clients);
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      }
    };
    fetchClients();
  }, []);
  const handleClientChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      clientId: selectedOption ? selectedOption.value : "",
    }));
  };

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/document-type`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDocuments(response.data.types);
      } catch (error) {
        console.error("Error fetching types:", error);
        setDocuments([]);
      }
    };
    fetchDocuments();
  }, []);
  const handleDocumentChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documenttypeId: selectedOption ? selectedOption.value : "",
      documentTypeName: selectedOption ? selectedOption.label : "",
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    if (
      vehicleRequiredDocs.includes(formData.documentTypeName) &&
      !formData.vehicleId
    ) {
      newErrors.vehicleId = `Vehicle is required for ${formData.documentTypeName}`;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const onChangeHandler = (event) => {
  //   const { name, value, files } = event.target;
  //   if (name === "documentCopy") {
  //     const file = files[0];
  //     if (file.size > 1048576) {
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         documentCopy: "Image size must not exceed 1MB",
  //       }));
  //     } else {
  //       setErrors((prevErrors) => ({
  //         ...prevErrors,
  //         documentCopy: "",
  //       }));
  //       setFormData((prevFormData) => ({
  //         ...prevFormData,
  //         documentCopy: file,
  //       }));
  //     }
  //   } else {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       [name]: value,
  //     }));
  //   }
  // };

  const onChangeHandler = (event) => {
    const { name, value, files } = event.target;

    if (name === "documentCopy") {
      const selectedFiles = Array.from(files); // ✅ newest selected files

      // ✅ Size validation (1MB per file)
      // const oversizedFile = selectedFiles.find((file) => file.size > 1048576);

      // if (oversizedFile) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     documentCopy: "Each file size must not exceed 1MB",
      //   }));
      //   return;
      // }

      setErrors((prev) => ({
        ...prev,
        documentCopy: "",
      }));

      // ✅ ✅ ✅ THIS IS THE KEY FIX → APPEND, NOT REPLACE
      setFormData((prev) => ({
        ...prev,
        documentCopy: [...prev.documentCopy, ...selectedFiles],
      }));

      // ✅ Reset input so selecting same file again also works
      event.target.value = "";
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: selectedOption ? selectedOption.value : "",
    }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return;
    }

    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const data = new FormData();
    data.append("comments", formData.comments);
    // data.append("Date", formData.Date);
    if (formData.Date) {
      data.append("Date", formData.Date);
    }

    data.append("pocName", formData.pocName);
    data.append("pocContact", formData.pocContact);
    // data.append("documentCopy", formData.documentCopy);
    formData.documentCopy.forEach((file) => {
      data.append("documentCopy", file); // ✅ SAME key multiple times (Multer expects this)
    });

    data.append("state", formData.state);

    if (formData.vehicleId) {
      data.append("vehicleId", formData.vehicleId);
    }
    if (formData.leaseId) {
      data.append("leaseId", formData.leaseId);
    }
    if (formData.clientId) {
      data.append("clientId", formData.clientId);
    }

    if (formData.documenttypeId) {
      data.append("documenttypeId", formData.documenttypeId);
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/insurance`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        navigate("/insurance");
      } else {
        console.error("Submission failed:", response.statusText);
      }
    } catch (error) {
      //   console.error("Error:", error);

      console.error("Error:", error.response ? error.response.data : error);
    }
  };
  const uniqueLeases = Array.from(
    new Map(leases.map((lease) => [lease.leasing_partner, lease])).values()
  );
  const removeDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documentCopy: prevFormData.documentCopy.filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <Layouts />
      <div className="container-fluid">
        <Breadcrumb title={title} brad={brad} />
        <form
          className="card"
          style={{ borderTop: "2px solid #4723d9" }}
          onSubmit={onSubmitHandler}
        >
          <div className="card-header d-flex justify-content-between border-bottom pb-1">
            <div className="">{title}</div>
            <div className="btn btn-info btn-sm" onClick={() => navigate(-1)}>
              Back
            </div>
          </div>
          <div className="card-body">
            <div className="row justify-content-center">
              <div className="col-md-6 mt-3">
                <label htmlFor="vehicleId">
                  <b>Vehicle </b>
                </label>
                <Select
                  name="vehicleId"
                  options={vehicles
                    .filter(
                      (vehicle) => vehicle.status?.toLowerCase() === "active"
                    )
                    .map((vehicle) => ({
                      value: vehicle._id,
                      label: vehicle.numberplate,
                    }))}
                  onChange={handleVehicleChange}
                  classNamePrefix="select"
                />
                {errors.vehicleId && (
                  <div className="text-danger mt-1">{errors.vehicleId}</div>
                )}
              </div>
              {/* <div className="col-md-6 mt-3">
                <label htmlFor="leaseId">
                  <b>Leasing Partner</b>
                </label>
                <Select
                  name="leaseId"
                  options={leases.map((lease) => ({
                    value: lease._id,
                    label: lease.leasing_partner,
                  }))}
                  onChange={handleLeaseChange}
                  classNamePrefix="select"
                />
              </div> */}

              <div className="col-md-6 mt-3">
                <label htmlFor="leaseId">
                  <b>Leasing Partner</b>
                </label>
                <Select
                  name="leaseId"
                  options={uniqueLeases.map((lease) => ({
                    value: lease._id,
                    label: lease.leasing_partner,
                  }))}
                  onChange={handleLeaseChange}
                  classNamePrefix="select"
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="clientId">
                  <b>Client</b>
                </label>
                <Select
                  name="clientId"
                  options={clients.map((client) => ({
                    value: client._id,
                    label: client.name,
                  }))}
                  onChange={handleClientChange}
                  classNamePrefix="select"
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="documenttypeId">
                  <b>Document Type *</b>
                </label>
                <Select
                  name="documenttypeId"
                  options={documents.map((type) => ({
                    value: type._id,
                    label: type.name,
                  }))}
                  onChange={handleDocumentChange}
                  classNamePrefix="select"
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="Date">
                  <b>Due Date </b>
                </label>
                <input
                  type="date"
                  name="Date"
                  onChange={onChangeHandler}
                  className="form-control"
                  value={formData.Date || ""}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="pocName">
                  <b>POC Name</b>
                </label>
                <input
                  type="text"
                  name="pocName"
                  placeholder="POC Name"
                  className="form-control"
                  value={formData.pocName}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="pocContact">
                  <b>POC Contact</b>
                </label>
                <input
                  type="number"
                  name="pocContact"
                  placeholder="POC Contact"
                  className="form-control"
                  value={formData.pocContact}
                  onChange={onChangeHandler}
                />
              </div>
              <div className="col-md-6 mt-3">
                <label htmlFor="state">
                  <b>State</b>
                </label>
                <input
                  type="text"
                  name="state"
                  placeholder="State"
                  className="form-control"
                  value={formData.state}
                  onChange={onChangeHandler}
                />
              </div>

              <div className="col-md-6 mt-3">
                <label htmlFor="documentCopy">
                  <b>Uploaded Documents *</b>
                </label>

                {/* ✅ SHOW SELECTED DOCUMENTS */}
                {formData.documentCopy.length > 0 ? (
                  <ul className="list-group">
                    {formData.documentCopy.map((file, index) => (
                      <li
                        key={index}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <div>
                          <strong>{file.name}</strong>{" "}
                          <span className="text-muted">
                            ({(file.size / 1024).toFixed(1)} KB)
                          </span>
                        </div>

                        {/* ✅ REMOVE BUTTON */}
                        <button
                          type="button"
                          className="btn btn-danger btn-sm"
                          onClick={() => removeDocument(index)}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No documents added yet.</p>
                )}

                {/* ✅ FILE INPUT AT BOTTOM (LIKE SEARCH INPUT IN YOUR REF) */}
                <input
                  type="file"
                  name="documentCopy"
                  className="form-control mt-2"
                  onChange={onChangeHandler}
                  accept="image/*,.pdf"
                  multiple
                />

                {/* ✅ ERROR DISPLAY */}
                {errors.documentCopy && (
                  <div className="text-danger mt-1">{errors.documentCopy}</div>
                )}
              </div>

              <div className="col-md-6 mt-3"></div>
              <div className="col-12 mt-3">
                <label htmlFor="comments">
                  <b>Comments</b>
                </label>
                <textarea
                  name="comments"
                  type="text"
                  placeholder="Enter Comment"
                  rows="5"
                  className="form-control"
                  value={formData.comments}
                  onChange={onChangeHandler}
                ></textarea>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-sm mt-3">
              Add Documents
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
